import apis from '@/apis';
export const FETCH_GLOBAL_INFO = 'FETCH_GLOBALINFO';
export const LOGIN_TYPE = 'LOGIN_TYPE';
export const CHANGE_VIEW_ROLE = 'CHANGE_VIEW_ROLE';

export function updateGlobalInfo(payload, duccRoutes) {
  return (dispatch, getState) => {
    if (payload && payload.ret === '0') {
      payload.data._duccRoutes = duccRoutes;
      dispatch({
        type: FETCH_GLOBAL_INFO,
        payload: payload.data,
      });
      dispatch({
        type: LOGIN_TYPE,
        payload: payload.loginType,
      });
    }
  };
}

export function changeViewRole() {
  return {
    type: CHANGE_VIEW_ROLE,
  };
}

const initialState = {
  loadedInfo: false,
  roles: {},
  userMap: {},
  // 有活动管理权限才有活动创建权限才有资源申请权限
  canApplyResource: false,
  loginType: '',
  roleIsCargoOwner: null,
};

export const ACTIVITY_MANAGE_MENU_ID = 10;

// 如果有活动管理栏目权限才有权限申请资源
function hasRightsToApplyReousrce(menus) {
  let canApplyResource = false;
  for (var i = 0, len = menus.length; i < len; i++) {
    if (menus[i].menuId === ACTIVITY_MANAGE_MENU_ID) {
      canApplyResource = true;
      break;
    }
  }

  return canApplyResource;
}

export default function userInfo(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_GLOBAL_INFO: {
      const canApplyResource = hasRightsToApplyReousrce(payload.menus);
      const systemRoleIsCargoOwner = getRoleIsCargoOwner(payload.roleRules);
      return Object.assign({}, state, payload, {
        loadedInfo: true,
        canApplyResource,
        roleIsCargoOwner: systemRoleIsCargoOwner
          ? true
          : getViewRoleCargoInStorage(payload.userMap.erp, systemRoleIsCargoOwner),
        hideRoleChangeBtn: systemRoleIsCargoOwner,
      });
    }
    case CHANGE_VIEW_ROLE: {
      const erp = state.userMap.erp;

      setViewRoleCargoInStorage(erp, !state.roleIsCargoOwner);

      return Object.assign({}, state, {
        roleIsCargoOwner: !state.roleIsCargoOwner,
      });
    }
    case LOGIN_TYPE: {
      window.ssoLoginType = payload;
      return Object.assign({}, state, { loginType: payload });
    }
    default:
      return state;
  }
}

function getRoleIsCargoOwner(roleRules = []) {
  const cargoOwnerCode = ['12', '17', '18', '19']; // 货主界面的code
  const fieldOwnerCode = ['13', '14', '15', '16', '1', '2']; // 场主界面的Code
  if (!roleRules.length) return null;
  // 纯货主角色展示为货主界面
  if (
    roleRules.find((ele) => cargoOwnerCode.includes(ele.code)) &&
    !roleRules.find((ele) => fieldOwnerCode.includes(ele.code))
  )
    return true;
  return false;
}

// 存在本地的状态
function getViewRoleCargoInStorage(erp, isCargo) {
  try {
    let viewRole = window.localStorage.getItem('VIEW_CARGO_ROLE');
    if (!viewRole) return isCargo;
    viewRole = JSON.parse(viewRole);
    if (viewRole[erp] == null) return isCargo;
    return viewRole[erp];
  } catch (ex) {
    console.error(ex);
  }

  return isCargo;
}

function setViewRoleCargoInStorage(erp, value) {
  try {
    let viewRole = window.localStorage.getItem('VIEW_CARGO_ROLE') || '{}';
    viewRole = JSON.parse(viewRole);
    viewRole[erp] = value;
    window.localStorage.setItem('VIEW_CARGO_ROLE', JSON.stringify(viewRole));
  } catch (ex) {
    console.error(ex);
  }
}
